module.exports = __webpack_public_path__ + "img/company3.611e1f9f.png";